module.exports = "<router-outlet>\n</router-outlet>"